var _excluded = ["show", "onDelete", "assignment", "context", "onClose", "onSaveDraft"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Fragment } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Button from "../../core/components/Button";
var CancelModal = function CancelModal(_ref) {
  var show = _ref.show,
    onDelete = _ref.onDelete,
    assignment = _ref.assignment,
    context = _ref.context,
    onClose = _ref.onClose,
    onSaveDraft = _ref.onSaveDraft,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var new_assignment_or_draft = context === 'assignment' && (assignment === null || assignment === void 0 ? void 0 : assignment.status) === 'draft';
  var text = new_assignment_or_draft ? 'Do you want to save this assignment before exiting?' : 'You have unsaved changes. Do you want to exit?';
  var goBack = function goBack() {
    return history.back();
  };
  var closeModal = function closeModal() {
    onClose();
  };
  var saveDraft = function saveDraft() {
    return onSaveDraft();
  };
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    isOpen: show,
    zIndex: 21800000000
  }, otherProps), /*#__PURE__*/React.createElement(ModalHeader, {
    charcode: "x",
    tag: "h5"
  }, "Confirm Action"), /*#__PURE__*/React.createElement(ModalBody, null, text), /*#__PURE__*/React.createElement(ModalFooter, null, new_assignment_or_draft && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
    outline: true,
    color: "nurture-orange",
    onClick: goBack,
    disabled: otherProps.submitting
  }, "Exit without saving"), /*#__PURE__*/React.createElement(Button, {
    color: "nurture-purple",
    onClick: saveDraft,
    disabled: otherProps.submitting,
    withLoader: true,
    loading: otherProps.submitting,
    loaderText: "Saving"
  }, "Save as Draft")), !new_assignment_or_draft && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
    outline: true,
    color: "nurture-orange",
    onClick: goBack
  }, "Exit without updating"), /*#__PURE__*/React.createElement(Button, {
    color: "nurture-purple",
    onClick: closeModal
  }, "Continue editing"))));
};
CancelModal.defaultProps = {
  context: 'assignment',
  onClose: undefined
};
export default CancelModal;